import React from 'react'
// import OurStorySlider from './OurStorySlider'
import { motion } from 'framer-motion'
import { useEffect, useRef } from 'react'

const Aboutus = () => {
    const sectionRef = useRef();


useEffect(() => {
  const element = sectionRef.current;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        element.classList.add('visible');
      }
    },
    { threshold: 0.2 }
  );

  if (element) {
    observer.observe(element);
  }

  return () => {
    if (element) {
      observer.unobserve(element);
    }
  };
}, []);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting) {
  //         sectionRef.current.classList.add('visible');
  //       }
  //     },
  //     { threshold: 0.2 }
  //   );

  //   if (sectionRef.current) {
  //     observer.observe(sectionRef.current);
  //   }

  //   return () => {
  //     if (sectionRef.current) {
  //       observer.unobserve(sectionRef.current);
  //     }
  //   };
  // }, []);
  return (
    <section className="abts">
      <div className="abts-1">
        <div className="abts-tte">
          <h2 className="">About Us</h2>
          <p>“For where two or three gather in my name, there am I with them.” — Matthew 18:20</p>
        </div>
        <div className="abts-str">
          <div className='abts-str1'>
            <h3 className="">Our Story...</h3>
            <p>
              David’s Court began as a small gathering of believers with a shared vision: to create a space where people could
              encounter God, grow in faith, and walk together in love. What started in a living room with prayer and worship
              has grown into a vibrant church family rooted in grace and truth.
            </p>
            <p>
              In our early days, we met with open Bibles and open hearts, seeking God’s direction for our lives and our community.
              Each step forward was marked by faith from our first worship night to our first outreach event, we saw God move in powerful ways.
            </p>
            <p>
              As we grew, so did our calling. We began serving our city through prayer walks, food drives, and mentorship programs.
              We welcomed people from all walks of life; seekers, skeptics, saints and watched as God knit us together into a spiritual home.
            </p>
            <p>
              Today, David’s Court is more than a church. It is a place of healing, restoration, and transformation.
              We are a multi-generational, multicultural community united by the love of Christ and committed to living out the gospel in everyday life.
            </p>
            <p className="about-highlight">
              Our story is still being written and we believe the best chapters are yet to come.
            </p>
          </div>
          {/* <OurStorySlider className="story-slider"/> */}
          {/* <img src="" alt="Our Story" className="abts-str-img" /> */}
        </div>
        <div className="mission-section" ref={sectionRef}>
             <div className="mission-container">
                <h2 className="mission-title">Our Mission</h2>
                <ul className="mission-list">
                    <li>1. To make heaven.</li>
                    <li>2. To take as many people with us.</li>
                    <li>3. To have a member of RCCG in every family of all nations.</li>
                    <li>4. To accomplish No. 1 above, holiness will be our lifestyle.</li>
                    <li>5. To accomplish No. 2 and 3 above, we will plant churches within five minutes walking distance in every city and town of developing countries and within five minutes driving distance in every city and town of developed countries.</li>
                    <li>6. We will pursue these objectives until every Nation in the world is reached for the Lord Jesus Christ.</li>
                </ul>
            </div>
        </div>
        <div className="beliefs-section">
            <div className="beliefs-container">
                <h2 className="beliefs-title">What We Believe</h2>
                <div className="beliefs-list">
                {[
                    {
                    title: 'GOD THE FATHER',
                    text: 'Creator of Heaven and Earth, who made man in His own image and likeness.',
                    refs: 'Gen 1:1, Gen 1:27',
                    },
                    {
                    title: 'JESUS CHRIST',
                    text: 'The only begotten Son of God the Father.',
                    refs: 'John 1:14-18, John 3:16',
                    },
                    {
                    title: 'THE HOLY SPIRIT',
                    text: 'The comforter and teacher of all things who dwells within us, uniting us to Jesus Christ.',
                    refs: 'Gen 1:2, Acts 1:8, John 14:26',
                    },
                    {
                    title: 'TRINITY',
                    text: 'We believe in one eternal God who exists in three Persons: Father, Son, and Holy Spirit. He is totally loving and completely holy.',
                    refs: '1 John 5:1-7',
                    },
                    {
                    title: 'THE DEATH AND RESURRECTION OF JESUS CHRIST',
                    text: 'Jesus died for the sins of mankind, rose on the third day, and ascended into heaven.',
                    refs: '1 Corinthians 15:3, 1 Peter 2:21-24',
                    },
                    {
                    title: 'THE BLOOD OF JESUS CHRIST',
                    text: 'Shed for us at Calvary. It cleanses us of all sin and grants us access into God’s presence.',
                    refs: 'Hebrews 12:24, Hebrews 10:19, 1 Peter 1:2, 1 John 1:7',
                    },
                    {
                    title: 'SALVATION',
                    text: 'A gift from God through grace and faith in Christ Jesus. All who believe may be saved.',
                    refs: 'Acts 4:10-12, John 3:16',
                    },
                    {
                    title: 'THE BAPTISM OF THE HOLY SPIRIT',
                    text: 'Available to all believers, evidenced by the gift of speaking in tongues.',
                    refs: 'Acts 1:8, Acts 2:1-4',
                    },
                    {
                    title: 'WATER BAPTISM',
                    text: 'By immersion in water as Jesus was baptized.',
                    refs: 'Colossians 2:12, Matthew 3:13-16, Romans 6:4',
                    },
                    {
                    title: 'SANCTIFICATION',
                    text: 'Separation from the world unto God — a life of true holiness.',
                    refs: '1 Corinthians 1:30, 2 Thessalonians 2:13, 1 Thessalonians 4:3',
                    },
                    {
                    title: 'HEAVEN AND HELL',
                    text: 'We believe in the reality of angels, demons, heaven, hell, and eternal judgment.',
                    refs: 'Matthew 25:41, Revelation 20:14-15, John 5:24, Mark 9:43-48, 2 Thessalonians 1:8-9',
                    },
                    {
                    title: 'THE SECOND COMING OF JESUS CHRIST',
                    text: 'Jesus will return in glory. The dead in Christ will rise, and believers will be with Him forever.',
                    refs: 'Acts 1:9-11, John 14:3, 1 Thessalonians 4:15-17, 1 Corinthians 15:51-52',
                    },
                    {
                    title: 'THE HOLY BIBLE',
                    text: 'The infallible and authoritative Word of God, inspired by the Holy Spirit.',
                    refs: '2 Timothy 3:16-17',
                    },
                    {
                    title: 'THE MANDATE',
                    text: 'Man was created to be fruitful, multiply, and have dominion over the earth.',
                    refs: 'Genesis 1:28',
                    },
                    {
                    title: 'MARRIAGE',
                    text: 'Marriage is between a man and a woman, joined as one flesh. All sex is reserved for marriage.',
                    refs: 'Genesis 2:24',
                    },
                ].map((item, idx) => (
                    <div key={idx} className="belief-card">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                    <span className="scripture-ref">{item.refs}</span>
                    </div>
                ))}
                </div>
            </div>
        </div>
        <div className="cta">
            <motion.button
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 2.5, duration: 1 }}
                    style={{ marginTop: '2rem', textAlign: 'center', pointerEvents: 'auto' }}
                    whileHover={{ scale: 1.1 }}
                    className="cta-button"
                    onClick={() => window.location.href = '/connect'}
                    >
                    Plan Your Visit
            </motion.button>
        </div>




      
      </div>
    </section>
  )
}

export default Aboutus